var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('dashboard-core-drawer',{attrs:{"toggled":_vm.toggled},on:{"toggled":_vm.onToggleClick}}),_c('dashboard-core-app-bar',{on:{"toggle":_vm.onToggleClick}}),_c('v-main',[_c('router-view'),_c('go-top',{attrs:{"bg-color":"#86BC26","size":35,"bottom":30,"has-outline":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }